module.exports = __webpack_public_path__ + "static/email-template-receipt-ccea150ca7cba7573ff9e335daa5b18a.jpg";